<template>
  <div v-if="isLoading || careTypeAutoSetFailed || sessionsLoadFailed" class="flex justify-center items-center min-h-400">
    <LoadingSpinner :width="48" :height="48" />
  </div>
  <BackupCareRequestSelection v-else :sc-care-sessions="scCareSessions" />
</template>

<script lang="ts">
import { sendSegmentEventWithTimeout } from '@/lib/segment';
import OnboardingMutations from '@/graphql/onboarding/mutations';
import { SC_CARE_SESSIONS_QUERY } from '@/graphql/backup_care/queries';
import LoadingSpinner from '@/components/spinner/Spinner.vue';
import BackupCareRequestSelection from './BackupCareRequestSelection.vue';
import { extractActiveScCareSessions, extractScCareSessions, inferCareTypeFromSessions } from '@/helpers/scCareSessionHelper';

export default {
  name: 'BackupCareRequest',
  components: {
    LoadingSpinner,
    BackupCareRequestSelection,
  },
  data() {
    return {
      isLoading: true,
      scCareSessions: [] as any[],
      careTypeAutoSetFailed: false,
      sessionsLoadFailed: false,
    };
  },
  async beforeMount() {
    await this.loadBackupCareSessions();
  },
  methods: {
    async loadBackupCareSessions() {
      try {
        const { data } = await this.$apollo.query({
          query: SC_CARE_SESSIONS_QUERY,
          fetchPolicy: 'network-only',
        });

        this.scCareSessions = extractScCareSessions(data);
        const activeSessions = extractActiveScCareSessions(data);

        if (activeSessions.length > 0) {
          try {
            await this.autoSetCareTypeForActiveSessions(activeSessions);
          } catch (error) {
            console.error(error);
            this.careTypeAutoSetFailed = true;
            await this.$router.push('/something-went-wrong?retry=true').catch(console.error);
            return;
          }
        }
      } catch (error) {
        console.error(error);
        this.sessionsLoadFailed = true;
        try {
          await this.$router.replace({
            path: '/corporate-onboarding/care-type',
            query: {
              ...this.$route.query,
              skip_backup_care: 'true',
            },
          });
        } catch (navigationError) {
          console.error(navigationError);
          await this.$router.push('/something-went-wrong?retry=true').catch(console.error);
        }
      } finally {
        this.isLoading = false;
      }
    },
    async autoSetCareTypeForActiveSessions(activeSessions: any[]): Promise<void> {
      const careType = inferCareTypeFromSessions(activeSessions);

      await this.$apollo.mutate({
        mutation: OnboardingMutations.COMPLETE_CARE_TYPE_TASK,
        variables: { careType },
      });
      await sendSegmentEventWithTimeout('Care Type Selected', { care_type: careType });
    },
  },
};
</script>
